import { OFFER_CONFIG } from "@constants";

interface IProspectPayload {
    brand: string;
    channelCode: string;
    channelType: string;
    offerType: string;
}

export const getPayload = (): IProspectPayload => ({
    brand: OFFER_CONFIG.BRAND,
    channelCode: OFFER_CONFIG.CHANNEL,
    channelType: OFFER_CONFIG.CHANNEL_TYPE,
    offerType: OFFER_CONFIG.OFFER_TYPE,
});
